import { useMemo } from 'react'

export const useBrowserDetection = () => {
	const isSafari = useMemo(() => {
		const ua = navigator.userAgent.toLowerCase()
		return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1
	}, [])

	const isChrome = useMemo(() => {
		const ua = navigator.userAgent.toLowerCase()
		return ua.indexOf('chrome') !== -1 && ua.indexOf('edg') === -1
	}, [])

	const isFirefox = useMemo(() => {
		const ua = navigator.userAgent.toLowerCase()
		return ua.indexOf('firefox') !== -1
	}, [])

	return { isSafari, isChrome, isFirefox }
}
